// extracted by mini-css-extract-plugin
export default {"pageWikiRubric":"WeKYi","container":"XFIHv ZdH1P","popularTags":"ckoXS","articlesCatalog":"SJpDs","afterRoomTourBlock":"lCacz"};